/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export const confirmSX: SxProps<Theme> = (theme) => ({
	backgroundColor: `${theme.palette.background.paper}${theme.palette.background.transparency}`,
	position: 'absolute',
	bottom: 0,
	height: '100%',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	'& .MuiButton-root': {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		'&:hover': {
			color: '#FFF',
			backgroundColor: theme.palette.primary.dark,
		},
	},
	'& .confirm-button': {
		fontWeight: 600,
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		'&:hover': {
			color: '#FFF',
			backgroundColor: theme.palette.primary.dark,
		},
	},
	'& .cancel-button': {
		fontWeight: 600,
		backgroundColor: '#F1F1F1',
		color: '#333',
		borderColor: '#F1F1F1',
		'&:hover': {
			color: '#FFF',
			backgroundColor: '#707070',
			borderColor: '#707070',
		},
	},
});
